module.exports = __webpack_public_path__ + "static/media/jaguar_logo.55233964.png";